import {observer} from "mobx-react";
import React from "react";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";

const ButtonRemoveFilters = observer(
    ({
         loading,
         onClick,
         style
     }: {
        loading: boolean
        onClick: () => void
        style?: React.CSSProperties

    }) => {

        return (
            <ButtonNew
                label={'Limpar filtros'}
                onClick={onClick}
                useIcon={false}
                sizeLeftIcon={15}
                disabled={loading}
                radius={25}
                style={style}
            />
        );
    })
export default ButtonRemoveFilters;